<template>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">
        {{ messages.length > 1 ? 'Important News' : messages[0].title }}
      </p>
      &nbsp;&nbsp;&nbsp;&nbsp;
      <button
        type="button"
        class="delete"
        v-on:click="$parent.close"/>
    </header>
    <div class="modal-card-body">
      <div v-for="(message, index) in messages">
        <p class="title is-5" v-if="messages.length > 1">
          {{ message.title }}
        </p>
        <p v-html="message.message"/>
        <br>
        <hr v-if="index !== messages.length - 1">
      </div>
    </div>
    <div class="modal-card-foot has-text-right">
      <b-button
        class="is-primary is-pulled-right"
        v-on:click="$parent.close"
      >
        Okay
      </b-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  components: {},
  props: {
    messages: Array,
  },
  methods: {},
  computed: {},
  created: function() {},
};
</script>

<style lang="scss">
</style>
